// @core/api/endpoints/team/reject_role_delegation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RejectRoleDelegationRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Reject delegation as delegate
 * Performs reject operation on role delegation.
 */
export async function RejectRoleDelegation(
  team_id: string,
  delegation_id: string,
  data: RejectRoleDelegationRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/delegations/:delegation_id/reject`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':delegation_id', encodeURIComponent(delegation_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
